import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { camelizeKeys } from 'humps';
import $ from 'jquery';
import padStart from 'string.prototype.padstart';
import Films from '../components/Films';

if (!String.prototype.padStart) { padStart.shim(); }

$(() => {
  const el = document.getElementById('films');
  const props = JSON.parse(el.dataset.props);
  ReactDOM.render(React.createElement(Films, camelizeKeys(props)), el);
});
